module.exports = __webpack_public_path__ + "static/media/3d-plan_Roots_add.5d722ac0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_Roots_add.svg
// module id = 867
// module chunks = 0